import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ensureDecorativeFontsLoaded } from 'src/utils/loadDecorativeFonts'
import { APP_CONSTANTS } from '../../constants'
import { getColorStyle, getTileCardDetails, getTitleParts } from '../../helpers/tileCardHelper'
import {
  TabAndTileCard,
  TabAndTileCardRow,
  TabAndTileCardsContainer,
  TabAndTileVerticalCard,
  TabAndTileVerticalCardRow,
  TabAndTileVerticalCardsContainer,
  TabAndTileVerticalDetails,
  TabAndTileVerticalImg,
  TileTitleFirstPart,
  TileTitleSecondPart,
  TileTitleVerticalFirstPart,
  TileTitleVerticalSecondPart,
  TileVerticalDescription,
} from './TabAndTileCardsStyles'

function cardFilter(card) {
  return card?.tabAndTile?.curatable || card?.tabAndTile?.id === 'practice'
}

export const renderCardsList = (props) => {
  const { cardsData } = props
  // filtering curatable false until support is extended
  const supportedTabTileList = cardsData?.filter(cardFilter)

  let parentArray = []

  while (supportedTabTileList?.length > 0) {
    parentArray.unshift(supportedTabTileList?.splice(0, 4))
  } //removing arrays containing at max 4 elements starting from index 0 in supportedTabTileList and inserting at beginning those arrays into parentArray

  return parentArray?.map((itemsRow, indexRow) => {
    return (
      <TabAndTileCardRow key={indexRow} itemsRowCount={itemsRow?.length}>
        {itemsRow?.map((card, index, rowArray) => {
          const { tileTitle, tilePrimaryColor, tileSecondaryColor, tileId, policyId, colors } =
            getTileCardDetails(card)
          // The second part which is the last word needs to have a different style
          const { titleFirstPart, titleSecondPart } = getTitleParts(tileTitle)

          return (
            <TabAndTileCard
              as={Link}
              to={`/tile/${tileId}${policyId ? `/${policyId}` : ''}`}
              background={getColorStyle(tilePrimaryColor, tileSecondaryColor, colors, 'lg')}
              key={index}
              itemsinrow={rowArray?.length}
            >
              <TileTitleFirstPart>{titleFirstPart}</TileTitleFirstPart>
              <TileTitleSecondPart>{titleSecondPart}</TileTitleSecondPart>
            </TabAndTileCard>
          )
        })}
      </TabAndTileCardRow>
    )
  })
}

export const renderVerticalCardsList = (props) => {
  const { cardsData } = props
  // filtering curatable false until support is extended
  const supportedTabTileList = cardsData?.filter(cardFilter)

  let parentArray = []

  if (supportedTabTileList?.length > 3) {
    while (supportedTabTileList?.length > 0) {
      parentArray.unshift(supportedTabTileList?.splice(0, 2))
    } //removing arrays containing at max 2 elements starting from index 0 in supportedTabTileList and inserting at beginning those arrays into parentArray
  } else {
    while (supportedTabTileList?.length > 0) {
      parentArray.unshift(supportedTabTileList?.splice(0, 1))
    } //removing arrays containing at max 1 elements starting from index 0 in supportedTabTileList and inserting at beginning those arrays into parentArray
  }

  return parentArray?.map((itemsRow, indexRow) => {
    return (
      <TabAndTileVerticalCardRow key={indexRow}>
        {itemsRow?.map((card, index, rowArray) => {
          const {
            tileTitle,
            tilePrimaryColor,
            tileSecondaryColor,
            tileId,
            policyId,
            description,
            image,
          } = getTileCardDetails(card)
          // The second part which is the last word needs to have a different style
          const { titleFirstPart, titleSecondPart } = getTitleParts(tileTitle)
          return (
            <TabAndTileVerticalCard
              as={Link}
              to={`/tile/${tileId}${policyId ? `/${policyId}` : ''}`}
              key={index}
              itemsinrow={rowArray?.length}
            >
              <TabAndTileVerticalDetails>
                <TileTitleVerticalFirstPart>{titleFirstPart}</TileTitleVerticalFirstPart>
                <TileTitleVerticalSecondPart>{titleSecondPart}</TileTitleVerticalSecondPart>
                <TileVerticalDescription>{description}</TileVerticalDescription>
              </TabAndTileVerticalDetails>

              <TabAndTileVerticalImg imgURL={APP_CONSTANTS.MEDIA_URL + image} />
            </TabAndTileVerticalCard>
          )
        })}
      </TabAndTileVerticalCardRow>
    )
  })
}

const TabAndTileCards = (props) => {
  const { cardsLayout } = props

  useEffect(() => {
    ensureDecorativeFontsLoaded()
  }, [])

  return (
    <>
      {cardsLayout === 'tab_tile_vertical' ? (
        <TabAndTileVerticalCardsContainer>
          {renderVerticalCardsList(props)}
        </TabAndTileVerticalCardsContainer>
      ) : (
        <TabAndTileCardsContainer>{renderCardsList(props)}</TabAndTileCardsContainer>
      )}
    </>
  )
}

export default TabAndTileCards
